import Swal from 'sweetalert2';

/**
 * Opens the shared print popup window, matching the historical `window.open('', 'PRINT', ...)`
 * call used across print flows. If the browser's popup blocker prevents the window from opening,
 * shows a SweetAlert2 warning asking the user to allow popups for this site, and returns null so
 * callers can bail out instead of throwing on a null window.
 */
export function openPrintWindow(features: string = 'height=1000,width=700'): Window | null {
  const mywindow = window.open('', 'PRINT', features);
  if (!mywindow) {
    const lang = localStorage.getItem('language') || 'en';
    Swal.fire({
      icon: 'warning',
      title: lang === 'ar' ? 'تم حظر النافذة المنبثقة' : 'Popup Blocked',
      text: lang === 'ar'
        ? 'الرجاء السماح بالنوافذ المنبثقة لهذا الموقع من إعدادات المتصفح للتمكن من الطباعة.'
        : 'Please allow popups for this site in your browser settings to enable printing.',
      confirmButtonText: lang === 'ar' ? 'حسناً' : 'OK',
    });
    return null;
  }
  return mywindow;
}
